export default __webpack_public_path__ + "static/media/cashout.89c6efa9.svg";